//TBS CUSTOM JS

//Journey Steps
// const journeySteps = document.querySelectorAll('.journey-step');

// function updateSteps() {
//   let activeIndex = -1;

//   journeySteps.forEach((step, index) => {
//     const rect = step.getBoundingClientRect();
    
//     // Step is active when it's near the center of the viewport
//     if (rect.top <= window.innerHeight * 0.4 && rect.bottom >= window.innerHeight * 0.4) {
//       activeIndex = index;
//     }
//   });

//   journeySteps.forEach((step, index) => {
//     step.classList.remove('active', 'highlighted');

//     if (index === activeIndex) {
//       step.classList.add('active');          // current step
//     }

//     if (index < activeIndex) {
//       step.classList.add('highlighted');     // all above steps
//     }
//   });
// }

// window.addEventListener('scroll', updateSteps);
// updateSteps(); // run initially


//SLider text fade in fade out


// document.querySelectorAll(".carousel-wrapper .control-button").forEach(function(button) {
//     button.addEventListener("click", function() {

//         // Fade-in effect for carousel text
//         const textElement = document.querySelector(".carousel-text.font-body");

//         if (textElement) {
//            //textElement.classList.remove("fade-in"); // Reset animation
//             //textElement.classList.remove("visible");
//             textElement.classList.add("fade-up");
           
//           setTimeout(function() {
//                  //textElement.classList.add("visible");
//                  textElement.classList.add("fade-up");
//             }, 300); // small delay to allow CSS to apply
           
//         }

//     });
// });

document.querySelectorAll(".carousel-wrapper .control-button").forEach(button => {
    button.addEventListener("click", () => {
        const textElement = document.querySelector(".carousel-text.font-body");

        if (!textElement) return;

        // Step 1: Fade out old text smoothly
        textElement.style.transition = "opacity 0s ease-out, transform 0s ease-out";
        textElement.style.opacity = 0;

      
            // Optional: update text content here
            // textElement.textContent = "New Slide Text";

            // Step 2: Instantly move text to the left (off-screen) WITHOUT transition
            textElement.style.transition = "none";
            textElement.style.transform = "translateX(-50px)";

            // Step 3: Force browser to register the new transform
            setTimeout(() => {
                // Step 4: Fade-in and move to original position smoothly
                textElement.style.transition = "opacity 1s ease-out, transform 2s ease-out";
                textElement.style.opacity = 1;
                textElement.style.transform = "translateX(0)";
            }, 400); // tiny delay to apply new transform
       
    });
});


//Hero Section Class change
document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".hero-section");
  const multicolumn = document.querySelectorAll(".multicolumn-logo-bar");

  sections.forEach((section, index) => {
    if (index > 0) {
      // Remove original class
      section.classList.remove("hero-section");

      // Add numbered class
      section.classList.add(`hero-section-${index + 1}`);
    }
  });

   multicolumn.forEach((multicolumns, index) => {
    if (index > 0) {
      // Remove original class
      multicolumns.classList.remove("multicolumn-logo-bar");

      // Add numbered class
      multicolumns.classList.add(`multicolumn-logo-bar-${index + 1}`);
    }
  });


});





// click
document.addEventListener('DOMContentLoaded', function() {

  const featureItems = document.querySelectorAll('.feature-item.tbs.font-body');
  const contentItems = document.querySelectorAll('.content-item.tbs-content');

  featureItems.forEach((item, index) => {
    item.addEventListener('click', function(e) {
      e.preventDefault();

      // Remove active from all feature items
      featureItems.forEach(el => el.classList.remove('active'));
      // Add active to clicked one
      item.classList.add('active');

      // Remove active from all content items
      contentItems.forEach(el => el.classList.remove('active'));
      // Add active to the corresponding content item
      const target = contentItems[index];
      target.classList.add('active');

      // Smooth scroll to that content item
      const offset = 100; // adjust for fixed header height
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

});

// scroll
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".tbs-content");
  const featureItems = document.querySelectorAll(".feature-item");

  const removeActive = () => {
    featureItems.forEach(item => item.classList.remove("active"));
    sections.forEach(sec => sec.classList.remove("active"));
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = entry.target.dataset.index;
          removeActive();
          entry.target.classList.add("active");
          featureItems[index].classList.add("active");
        }
      });
    },
    {
      threshold: 0.6, // section must be at least 60% visible to activate
    }
  );

  sections.forEach(section => observer.observe(section));

  // Optional: allow click on feature items to scroll to content
  featureItems.forEach(item => {
    item.addEventListener("click", () => {
      const index = item.dataset.index;
      const targetSection = document.querySelector(
        `.tbs-content[data-index="${index}"]`
      );
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  });
});




//fadein add visible
const sections = document.querySelectorAll('.fade-in');
const sections2 = document.querySelectorAll('.fade-in-2');


const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, {
  threshold: 0   // 20% visible triggers the animation
});

sections.forEach(sec => observer.observe(sec));
sections2.forEach(sec => observer.observe(sec));

document.addEventListener("DOMContentLoaded", function () {
  // Select all section elements
  const sections = document.querySelectorAll("section");

  sections.forEach(section => {
    // Find the first div inside the section
    const innerDiv = section.querySelector(":scope > div");
    if (!innerDiv) return;
     if(section.querySelector(":scope > div.testimonials-section")){

     const container1 = section.querySelector("div.testimonials-heading");
     container1.classList.add("container");
     return;
     } 
    // Create the new container div
    const container = document.createElement("div");
    container.classList.add("container");

    // Move all children of innerDiv into container
    while (innerDiv.firstChild) {
      container.appendChild(innerDiv.firstChild);
    }

    // Put container back inside innerDiv
    innerDiv.appendChild(container);
  });
});


//Scroll Text show 1 by 1 fade in effect (Guri)

window.addEventListener("load", () => {
  setTimeout(() => {

document.querySelectorAll(".hero-section-2 .body-text p").forEach(block => {
  const text = block.textContent.trim();
  block.textContent = "";
  
  text.split(" ").forEach(char => {
    const span = document.createElement("span");
        const span1 = document.createElement("span");
    span.textContent = char;

span1.classList.add("fade-char-br");
span1.innerHTML = "&nbsp;";

    span.classList.add("fade-char");
    block.appendChild(span);
     block.appendChild(span1);
  });
});
window.addEventListener("scroll", () => {
  document.querySelectorAll(".hero-section-2 .body-text p").forEach(block => {
    const rect = block.getBoundingClientRect();
    const chars = block.querySelectorAll(".fade-char");

    const windowHeight = window.innerHeight;
    const startPoint = windowHeight - 100; // start fade 100px from bottom

    if (rect.top > startPoint) {
      chars.forEach(c => c.style.opacity = 0);
      return;
    }

    // Scroll progress 0 → 1
    let progress = 1 - ((rect.bottom - startPoint) / rect.height);
    progress = Math.min(Math.max(progress, 0), 1);

    const visibleChars = Math.floor(progress * chars.length);
    const tailLength = 1; // number of chars that get opacity 0.5

    chars.forEach((char, index) => {
      if (index < visibleChars) {
        char.style.opacity = 1; // fully visible
       
      }
      else if (index < visibleChars + tailLength) {
        
        char.style.opacity = 1; // fade tail
        if(index+1 != chars.length){
        char.classList.add("fade-char-last");
        }
      }
      else {
        char.style.opacity = 0; // hidden
         char.classList.remove("fade-char-last");
         
      }
    });
  });
});
  }, 1000); // end setTimeout 100ms delay
})

// testimonial-slider-left-alignment 25-11-2025
document.addEventListener("DOMContentLoaded", () => {
function updatePadding() {
const el = document.querySelector('.testimonials-section > .testimonials-heading .heading ');
const container = document.querySelector('.testimonials-section .testimonials-container');

const distance = el.getBoundingClientRect().left;
container.style.paddingLeft = distance + 'px';
}
window.addEventListener('resize', updatePadding);
updatePadding(); // run once
})



//Mobile Tabs 
// document.addEventListener("DOMContentLoaded", function () {
//   const tabs = document.querySelectorAll(".mobile-tab");
//   const contents = document.querySelectorAll(".tbs-content");
//   const tabsContainer = document.querySelector(".mobile-tabs");

//   function showTab(index) {
//     tabs.forEach((t, i) => {
//       t.classList.toggle("active", i === index);
//     });
//     contents.forEach((c, i) => {
//       c.style.display = i === index ? "block" : "none";
//     });
//   }

//   function setupMobileTabs() {
//     if (window.innerWidth <= 900) {
//       // Initialize
//       showTab(0);

//       tabs.forEach((tab, index) => {
//         tab.addEventListener("click", function (e) {
//           e.preventDefault();
//           e.stopImmediatePropagation();

//           // Disable anchor scroll
//           history.replaceState(null, "", window.location.pathname + window.location.search);

//           // Switch tab content
//           showTab(index);

//           // Scroll back to tabs section (smoothly)

//           if (tabsContainer) {
//             const topOffset = tabsContainer.getBoundingClientRect().top + window.scrollY + -80;
//           window.scrollTo({ top: topOffset});
//           }
//         });

//         // Disable href on mobile to prevent scroll jumps
//         tab.removeAttribute("href");
//       });
//     } else {
//       // Restore desktop behavior
//       contents.forEach((c) => (c.style.display = ""));
//       tabs.forEach((tab, i) => {
//         const targetId = contents[i]?.id;
//         if (targetId) tab.setAttribute("href", "#" + targetId);
//       });
//     }
//   }

//   setupMobileTabs();
//   window.addEventListener("resize", setupMobileTabs);
// });


/// scrooll than add active class or remove other active class (GURI)
// const steps = document.querySelectorAll('.journey-step');

// function handleScroll() {
//   const scrollTop = window.scrollY;

//   steps.forEach(step => {
//     const rect = step.getBoundingClientRect();
//     const stepTop = rect.top + window.scrollY; // Element's distance from top of document

//     // Check if step is within 100px from top of viewport
//     if (scrollTop + 360 >= stepTop && scrollTop + 100 < stepTop + rect.height) {
//       // Remove active from all steps
//       steps.forEach(s => s.classList.remove('active'));
//       // Add active to the current step
//       step.classList.add('active');
//     }
//   });
// }

// // Listen to scroll events
// window.addEventListener('scroll', handleScroll);

// // Trigger it once on page load in case some step is already in view
// handleScroll();


//Slider images fsde in fateout
// const bgElement = document.querySelector('[id^="carouselSection-"]');
// const textElement = document.querySelector(".carousel-text.font-body p");

// // Example dynamic images (replace with yours)
// const images = [
//     "url(https://www.actualbody.com/cdn/shop/files/DTS_Warm_Up_Daniel_Faro_Photos_ID7112_1_2.png?v=1762292631&width=1400)",
//     "url(https://www.actualbody.com/cdn/shop/files/DTS_Warm_Up_Daniel_Faro_Photos_ID7112_1_2.png?v=1762292631&width=1400)",
//     "url(https://www.actualbody.com/cdn/shop/files/DTS_Warm_Up_Daniel_Faro_Photos_ID7112_1_2.png?v=1762292631&width=1400)"
// ];

// let currentIndex = 0;

// // Handle button click
// document.querySelectorAll(".carousel-wrapper .control-button").forEach(btn => {
//     btn.addEventListener("click", function() {

//         // 1. FADE OUT background + text
//         bgElement.classList.remove("fade-in");
//         bgElement.classList.add("fade-out");

//         textElement.classList.remove("fade-in");
//         textElement.classList.add("fade-out");

//         // 2. Wait for fade-out, then change background
//         setTimeout(() => {

//             // Change image dynamically
//             currentIndex = (currentIndex + 1) % images.length;
//             bgElement.style.backgroundImage = images[currentIndex];

//             // 3. FADE IN both
//             bgElement.classList.remove("fade-out");
//             bgElement.classList.add("fade-in");

//             textElement.classList.remove("fade-out");
//             textElement.classList.add("fade-in");

//         }, 300); // matches CSS transition time
//     });
// });


//left Marquee
// document.addEventListener("DOMContentLoaded", () => {
//   const list = document.querySelector("#shopify-section-template--18371655565391__multicolumn_c8UwCR .multicolumn-list");

//   // Wrap list in marquee wrapper
//   const wrapper = document.createElement("div");
//   wrapper.classList.add("clhs");
//   list.parentNode.insertBefore(wrapper, list);
//   wrapper.appendChild(list);

//   // Add marquee animation class
//   list.classList.add("crhs-track-lhs");

//   // Duplicate for continuous loop
//   list.innerHTML += list.innerHTML;
// });

//Right Marquee
// document.addEventListener("DOMContentLoaded", () => {
//   const list = document.querySelector("#shopify-section-template--18371655565391__multicolumn_Df8TzC .multicolumn-list");

//   // Wrap list in marquee wrapper
//   const wrapper = document.createElement("div");
//   wrapper.classList.add("crhs");
//   list.parentNode.insertBefore(wrapper, list);
//   wrapper.appendChild(list);

//   // Add marquee animation class
//   list.classList.add("crhs-track-rhs");

//   // Duplicate for continuous loop
//   list.innerHTML += list.innerHTML;
// });

